import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AddressesUrlParams } from "../../parameters/addresses-url-params";

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
  providers: []
})
export class IndexComponent implements OnInit {

  public fondoImgSrc: string = "assets/images/img_fondo.png";

  showloading: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/index/index.component.ts